<template>
  <div class="ios-gps2">
    <div class="modal ios-gps-modal2">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body" style="background-color:#f1f1f1;">
          <h1 class="has-text-link is-size-5 has-text-weight-semibold">{{ $t("ios-gps-title") }}</h1>
          <br />
          <div>
            <div>
              <!-- Step 1 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-1") }}</p>
              <p>
                <img
                  src="../assets/ios_system_settings.png"
                  style="height:80px; border-radius:20%;"
                />
              </p>
              <br />

              <!-- Step 2 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-2") }}</p>
              <p>
                <img :src="$t('ios.gps-img-1')" />
              </p>
              <br />

              <!-- Step 3 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-3") }}</p>
              <p>
                <img :src="$t('ios.gps-img-2')" />
              </p>
              <br />

              <!-- Step 4 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-4") }}</p>
              <p>
                <img :src="$t('ios.gps-img-3')" />
              </p>
              <br />

              <!-- Step 5 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-5") }}</p>
              <p>
                <img :src="$t('ios.gps-img-4')" />
              </p>
              <br />

              <!-- Step 6 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("ios.gps-step-6") }}</p>
              <!-- <br /> -->

              <a class="button is-link" @click="closeModal">{{ $t("close") }}</a>
            </div>
          </div>
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "IOSGPSModal2",
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    }
  }
};
</script>